import { Box, Button, Grid, Modal } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CompanyNamePICModel from '../../../CompanyNamePIC/models/CompanyNamePICModel';
import CompanyNamePICSelector from '../../../CompanyNamePICSelector/CompanyNamePICSelector';
import './SupportSheetPrinciple.scss';

interface SupportSheetPrincipleProp {
    selectedPrincipleId: string,
    disabled?: boolean,
    onChange?: (selectedId: string, selectedItem: CompanyNamePICModel | null) => void,
    className?: string,
}

const SupportSheetPrinciple: React.FunctionComponent<SupportSheetPrincipleProp> = (props) => {
    const dispatch = useDispatch();
    const [showPrincipleInput, setShowPrincipleInput] = useState<boolean>(false);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "800px",
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <>
            <Button
                variant='contained'
                className='support-sheet-principle-button'
                color={props.disabled ? "success" : "primary"}
                disabled={props.disabled}
                onClick={() => {
                    setShowPrincipleInput(true);
                }}
            ><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button>
            <Modal
                open={showPrincipleInput}
                onClose={() => {
                    setShowPrincipleInput(false);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid item xs={10}>
                            <CompanyNamePICSelector
                                label='Company Name'
                                selectedId={props.selectedPrincipleId}
                                onChange={(selectedItem: CompanyNamePICModel | null) => {
                                    if (props.onChange) {
                                        props.onChange(selectedItem ? selectedItem.id : "", selectedItem);
                                    }
                                }}
                            >
                            </CompanyNamePICSelector>
                        </Grid>
                        <Grid item xs={2}>
                            <Button
                                onClick={() => {
                                    setShowPrincipleInput(false);
                                }}
                                variant="outlined"
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
};

export default SupportSheetPrinciple;